import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Calendar, Clock, Wrench, CircleCheck, ArrowRight } from "lucide-react";
const timelineSteps = [];
export default function RepairDelayInformation() {
  return <section data-section-id="252671" id="service-overview" className="bg-background text-foreground py-16 relative overflow-hidden min-h-[700px] flex items-center md:py-24 lg:py-32">
      {/* Background Blurs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10 z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-lg bg-primary blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-secondary blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {/* Text Content */}
          <div className="flex flex-col justify-center space-y-8 max-w-xl mx-auto lg:mx-0">
            <div className="inline-flex items-center gap-2 border border-[#00d2ff] rounded-full px-4 py-1.5 text-white font-semibold text-xs tracking-widest uppercase mb-2 w-max bg-[#22c55e]/10">
              <SafeHydrate><Calendar className="lucide lucide-calendar w-4 h-4 !text-[rgba(0,210,255,1)]" /></SafeHydrate>
              <span>ԲԱՐՁՐ ՃՇԳՐՏՈՒԹՅԱՆ ՏՎՅԱԼՆԵՐ</span>
            </div>
            
            <div className="space-y-6">
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-foreground">Ռելիեֆի և տեղանքի թվային մոդելների ստեղծում DSM/DTM</h1>
              <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">
                Գեոկոսմոս ՓԲԸ-ն առաջարկում է առաջադեմ ֆոտոգրամետրիական լուծումներ՝ 
                օգտագործելով արբանյակային և օդային գերճշգրիտ տվյալներ։ Մեր ինժեներական 
                մոտեցումը ապահովում է հուսալի և մանրամասն տարածական մոդելավորում ձեր 
                ռազմավարական նախագծերի համար։
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base h-14 px-8 rounded-md shadow-md shadow-primary/20">
                {/* Add button content here */}
              </Button>
              <Button asChild size="lg" variant="outline" className="bg-transparent border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground text-base h-14 px-8 rounded-md transition-colors">
                {/* Add button content here */}
              </Button>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative flex justify-center lg:justify-end">
            {/* Image Container - Styled to match the glowing rounded border in the photo */}
            <div className="relative rounded-2xl overflow-hidden border border-emerald-500/40 shadow-[0_0_30px_rgba(16,185,129,0.15)] max-w-full w-[600px]">
              <div className="absolute top-0 left-0 w-full h-8 bg-black/40 flex items-center px-4 gap-2 border-b border-white/10 z-10">
                 {/* Decorative window dots */}
                 <div className="w-2.5 h-2.5 rounded-full bg-emerald-500/50"></div>
                 <div className="w-2.5 h-2.5 rounded-full bg-emerald-500/50"></div>
                 <div className="w-2.5 h-2.5 rounded-full bg-emerald-500/50"></div>
              </div>
              
              <img src="https://summary-monarch-dev.10web.cloud/wp-content/uploads/2026/05/4a5d2122-fd1c-44df-bac6-997d0a455ba3.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/digital_elevation_model_visualization.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/digital_elevation_model_visualization.png-wvc-sizes" alt="Ֆոտոգրամետրիական աշխատանքներ" className="w-full h-auto object-cover rounded-2xl" loading="lazy" />
            </div>

            {/* Timeline Steps (Hidden if empty, safe to keep here) */}
            <div className="relative lg:absolute lg:-left-12 lg:top-1/2 lg:-translate-y-1/2 mt-8 lg:mt-0 w-full lg:w-[110%] space-y-4 z-20 pointer-events-none">
              {timelineSteps.map((step, i) => {
              const Icon = step.icon;
              return <div key={i} data-index={i} className="bg-card text-card-foreground p-5 rounded-md shadow-lg border border-border flex items-start gap-4 transform transition-transform hover:-translate-y-1 pointer-events-auto">
                    <div className="bg-primary/10 p-3 rounded-md shrink-0">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-1">
                        <h3 className="font-default font-bold text-lg">{step.title}</h3>
                      </div>
                      <p className="font-default text-sm text-muted-foreground">
                        {step.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </div>

        </div>
      </div>
    </section>;
}